import { render, staticRenderFns } from "./ProjectGoals.vue?vue&type=template&id=7e28971e&"
import script from "./ProjectGoals.vue?vue&type=script&lang=js&"
export * from "./ProjectGoals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports